import { render, staticRenderFns } from "./email_update.vue?vue&type=template&id=50e7ada6&scoped=true&"
import script from "./email_update.vue?vue&type=script&lang=js&"
export * from "./email_update.vue?vue&type=script&lang=js&"
import style0 from "./email_update.vue?vue&type=style&index=0&id=50e7ada6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7ada6",
  null
  
)

export default component.exports